import {useEffect} from 'react';

import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';
import useMenuVisibility from '@/hooks/useMenuVisibility';

const BadgesPage = () => {
    const {showMenu} = useMenuVisibility();

    useEffect(() => {
        showMenu();
    }, [showMenu]);

    return <DynamicPage pageId={PAGE_IDS.BADGES} className='pb-app-menu pt-app-4' />;
};

export default BadgesPage;
